module.exports = __webpack_public_path__ + "7f775a4767e4a085422f25887d160ece.svg";